import React from 'react';
import type {
  RaterXCoverage,
  Waiver,
} from '../../../../../../api/types/rater-x-preset';
import type { UpdateCoveragePayload } from '../../../../../../reducer';
import type { WaiverOfSubrogationFormValues } from '../WaverOfSubrogationModal';
import { WaverOfSubrogationModal } from '../WaverOfSubrogationModal';
import {
  formatWaiversForState,
  getDefaultWaiverValues,
} from '../../amendatory-coverages/line-items/WaiverOfSubrogation';

const RaterXWaiverOfSubrogationModal = ({ data, close }: ModalProps) => {
  const onSubmit = (formValues: WaiverOfSubrogationFormValues) => {
    const _waivers = formatWaiversForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          items: { values: _waivers as unknown as Waiver[] },
        },
      },
    });
  };

  return (
    <WaverOfSubrogationModal
      close={close}
      data={{
        onSubmit,
        waivers: getDefaultWaiverValues(
          data.coverageState.value?.props?.items?.values as Waiver[]
        ),
      }}
    />
  );
};

type ModalProps = {
  data: {
    coverageState: RaterXCoverage;
    setCoverage: (payload: UpdateCoveragePayload) => void;
  };
  close: () => void;
};

export const RaterXWaiverOfSubrogationModalConfig = {
  RaterXWaiverOfSubrogationModal: {
    component: RaterXWaiverOfSubrogationModal,
    config: {
      title: 'Waiver of Subrogation',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
